module.exports = __webpack_public_path__ + "img/img_safety_phone_img1.e1db89dc.png";